import { isObject } from '@iconik-io/core/src/is_object';

import type {
  FilterValue,
  FilterValueStoredIn,
} from '../../redux/common_filters/types';

export function isStoredInArray(
  values: unknown[],
): values is FilterValueStoredIn[] {
  return values.every(
    (value) => isObject(value) && 'storageId' in value && 'operator' in value,
  );
}

export function guardFilterStoredIn(
  filterValue: FilterValue,
): FilterValueStoredIn[] | undefined {
  if (
    Array.isArray(filterValue) &&
    filterValue.length > 0 &&
    isStoredInArray(filterValue)
  ) {
    return filterValue;
  }
  return undefined;
}
